export default __webpack_public_path__ + "static/media/281.177bee37.jpg";